module.exports = __webpack_public_path__ + "img/Aladdin.386dc721.png";